export * from './cases.service';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/services/index.ts